var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { State, Store, Action, Selector } from '@ngxs/store';
import { SaveModule, SaveModuleThumbnails, SaveModuleSuccess, SaveModuleFailure, ResetModules, SetSaveModule, GetModulePrimaryCategories, GetModuleSecondaryCategories, DuplicateModuleSuccess, DuplicateModuleFailure } from './modules.actions';
import { SerializeModuleService } from 'src/app/edit/serialize-module.service';
import { TrimConfiguration } from 'src/app/edit/models/trim-config.model';
import { ModulesService } from '../modules.service';
import { ModulesSaveResultEnum } from '../models/modules-save-result.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ModulesThumbnailService } from '../modules-thumbnail.service';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { forkJoin } from 'rxjs';
import { take, finalize } from 'rxjs/operators';
import { SaveModuleModel } from '../models/save-module.model';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { StoryService } from 'src/app/story/story.service';
import { SetStory, SetStoryId } from 'src/app/story/state/story.actions';
import { StoryState } from 'src/app/story/state/story.state';
var initialTrim = new TrimConfiguration();
initialTrim.graph.hidden = true;
var initialState = {
    primaryCategoryOptions: [],
    secondaryCategoryOptions: [],
    moduleExists: false,
    saveModule: new SaveModuleModel(),
    storyType: StoryType.Module,
    saving: false
};
var ModulesState = /** @class */ (function () {
    function ModulesState(store, serializeModuleService, modulesService, modulesThumbnailService, storyService) {
        this.store = store;
        this.serializeModuleService = serializeModuleService;
        this.modulesService = modulesService;
        this.modulesThumbnailService = modulesThumbnailService;
        this.storyService = storyService;
    }
    ModulesState.getSaveModule = function (state) {
        return state.saveModule;
    };
    ModulesState.getPrimaryCategoryOptions = function (state) {
        return state.primaryCategoryOptions;
    };
    ModulesState.getSecondaryCategoryOptions = function (state) {
        return state.secondaryCategoryOptions;
    };
    ModulesState.getSaving = function (state) {
        return state.saving;
    };
    ModulesState.prototype.saveModule = function (context, action) {
        var _this = this;
        context.patchState({ saving: true });
        // Prepare the save configurations
        var saveConfig = action.saveConfig;
        var trimConfig = action.trimConfig ? action.trimConfig : new TrimConfiguration();
        // Generate a new namespace map for the serialize object, included all child properties.
        // Then serialize the module.
        var namespaceMap = saveConfig.duplicate ? action.saveConfig.namespaceMap : {};
        // Pull the labels out of state and merge into the story before serialization
        var labels = this.store.selectSnapshot(StoryLabelsState.getLabels);
        var chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        this.storyService.storeLabelsInChapters(labels, chapters);
        var serialized = this.serializeModuleService.serialize(saveConfig.replace, namespaceMap, trimConfig, action.saveConfig.duplicate, this.store.selectSnapshot(StoryState.getStory), this.store.selectSnapshot(StoryChaptersState.getStoryChapters));
        // Save module file to the server.
        this.modulesService.saveModule(serialized.story, action.id)
            .pipe(finalize(function () { return context.patchState({ saving: false }); }))
            .subscribe(function (result) {
            if (result === ModulesSaveResultEnum.Success) {
                if (serialized) {
                    _this.store.dispatch(new SetStory(serialized.story));
                }
                _this.store.dispatch(new SetStoryId(action.id));
                context.dispatch(new SaveModuleSuccess(action.id));
                // lazy save the thumbnails. 
                context.dispatch(new SaveModuleThumbnails(action.id, serialized, saveConfig));
            }
            else {
                context.dispatch(new SaveModuleFailure(action.id));
            }
        });
        // Duplicate module [working]
        if (saveConfig.duplicate) {
            var copyRequests$_1 = [];
            Object.entries(namespaceMap)
                .forEach(function (_a) {
                var _b = __read(_a, 2), sourceState = _b[0], targetState = _b[1];
                copyRequests$_1.push(_this.modulesService.copyState(sourceState, targetState));
            });
            forkJoin(copyRequests$_1)
                .subscribe(function (success) {
                context.dispatch(new DuplicateModuleSuccess(action.id));
            }, function (error) {
                context.dispatch(new DuplicateModuleFailure(action.id));
            });
        }
    };
    // Send thumbnail data to server through thumbnail services
    // # FIXME: Work with @Brandon to support copying of thumbnails from module to module
    ModulesState.prototype.saveModuleThumbnails = function (context, action) {
        // const { serialized, moduleId, saveConfig } = context.getState();
        var thumbs = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
        // call service to save
        var indexId = action.serialized.story.chapters[0].id;
        this.modulesThumbnailService.saveStoryThumbnails({
            storyId: action.id,
            storyType: StoryType.Module,
            thumbnails: thumbs,
            chapterIdMap: action.serialized.chapterIdMap,
            indexId: indexId,
            deleteUnused: action.saveConfig.replace
        }).subscribe(function (success) {
        });
    };
    ModulesState.prototype.setSaveModule = function (context, action) {
        context.patchState({
            saveModule: __assign({}, action.module)
        });
    };
    ModulesState.prototype.getModulePrimaryCategories = function (context, action) {
        this.modulesService.getPrimaryCategories()
            .subscribe(function (categories) {
            context.patchState({
                primaryCategoryOptions: categories
            });
        });
    };
    ModulesState.prototype.getModuleSecondaryCategories = function (context, action) {
        this.modulesService.getSecondaryCategories(action.primaryCategory)
            .subscribe(function (categories) {
            context.patchState({
                secondaryCategoryOptions: categories
            });
        });
    };
    // # TODO: Wire up full state reset, not just patchState
    ModulesState.prototype.resetModules = function (context, action) {
        forkJoin(this.modulesService.getPrimaryCategories(), this.modulesService.getSecondaryCategories(''))
            .pipe(take(1))
            .subscribe(function (_a) {
            var _b = __read(_a, 2), primaryCategories = _b[0], secondaryCategories = _b[1];
            context.patchState({
                primaryCategoryOptions: primaryCategories,
                secondaryCategoryOptions: secondaryCategories
            });
        });
    };
    __decorate([
        Action(SaveModule),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SaveModule]),
        __metadata("design:returntype", void 0)
    ], ModulesState.prototype, "saveModule", null);
    __decorate([
        Action(SaveModuleThumbnails),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SaveModuleThumbnails]),
        __metadata("design:returntype", void 0)
    ], ModulesState.prototype, "saveModuleThumbnails", null);
    __decorate([
        Action(SetSaveModule),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetSaveModule]),
        __metadata("design:returntype", void 0)
    ], ModulesState.prototype, "setSaveModule", null);
    __decorate([
        Action(GetModulePrimaryCategories),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetModulePrimaryCategories]),
        __metadata("design:returntype", void 0)
    ], ModulesState.prototype, "getModulePrimaryCategories", null);
    __decorate([
        Action(GetModuleSecondaryCategories),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, GetModuleSecondaryCategories]),
        __metadata("design:returntype", void 0)
    ], ModulesState.prototype, "getModuleSecondaryCategories", null);
    __decorate([
        Action(ResetModules),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetModules]),
        __metadata("design:returntype", void 0)
    ], ModulesState.prototype, "resetModules", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ModulesState, "getSaveModule", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ModulesState, "getPrimaryCategoryOptions", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ModulesState, "getSecondaryCategoryOptions", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ModulesState, "getSaving", null);
    ModulesState = __decorate([
        State({
            name: 'modules',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [Store,
            SerializeModuleService,
            ModulesService,
            ModulesThumbnailService,
            StoryService])
    ], ModulesState);
    return ModulesState;
}());
export { ModulesState };
